import Menubar from "../../Components/Menubar/Menubar";
import Navbar from "../../Components/Navbar/Navbar";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Modal from "./Components/Modal";
import XenieLogoDark from "../../Assets/XenieLogoDark.png";

function SharedLayout() {
    const modalDisplay = useSelector((state) => state.search.modalDisplay);
    const location = useLocation();

    return (
        <div className="flex max-h-screen">
            {(location.pathname !== "/notifications" && location.pathname !== "/settings") ? (
                <>
                    <div className="w-[17%] max-[1280px]:w-[19.5%] max-[1180px]:w-[22%]">
                        <Menubar />
                    </div>

                    <div className="flex flex-col w-[83%] max-[1280px]:w-[80.5%] max-[1180px]:w-[78%]">
                        <Navbar />

                        <Outlet />
                    </div>
                </>
            ) : (
                <div className="flex flex-col w-full">
                    <div className="flex">
                        <div className="flex items-center w-[17%] max-[1280px]:w-[19.5%] max-[1180px]:w-[22%] px-2 border-b border-[#E5E7EB]">
                            <div className="px-2 h-12 flex items-center">
                                <Link to="/">
                                    <img className="w-auto h-10" src={XenieLogoDark} alt="xenie-logo" />
                                </Link>
                            </div>
                        </div>

                        <div className="flex flex-col w-[83%] max-[1280px]:w-[80.5%] max-[1180px]:w-[78%]">
                            <Navbar />
                        </div>
                    </div>

                    <Outlet />
                </div>
            )}

            {modalDisplay && <Modal />}
        </div>
    );
}

export default SharedLayout;
